<template>
    <footer class="footer footer--4">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <logo></logo>
                    <footer-nav></footer-nav>
                </div>
                <div class="col-lg-6">
                    <contacts></contacts>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <paysistems></paysistems>
                </div>
                <div class="col-lg-6">
                    <copyright></copyright>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import Logo from "./parts/Logo.vue";
import FooterNav from "./parts/FooterNav.vue";
import Contacts from "./parts/Contacts.vue";
import Paysistems from "./parts/Paysistems.vue";
import Copyright from "./parts/Copyright.vue";

export default {
    components: {
        Logo,
        FooterNav,
        Contacts,
        Paysistems,
        Copyright,
    },
};
</script>

<style lang="scss">
.footer--4 {
    &.footer {
        padding: 60px 60px 40px 60px;
        background-color: $main-dark;
        .footer__logo {
            margin-bottom: 40px;
            img {
                max-width: 390px;
                height: auto;
            }
        }
        .footer__menu {
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin-bottom: 60px;
            li {
                a {
                    color: $main-light;
                    @include font(16, 400);
                    padding: 2px 4px;
                    transition: $transition;
                    &:hover {
                        background-color: $main-light;
                        color: $main-dark;
                    }
                }
            }
        }
        .footer__contacts {
            display: flex;
            flex-direction: column;
            gap: 8px;
            height: calc(100% - 60px);
            margin-bottom: 60px;
            &-item {
                @include font(16, 400);
                color: $main-light;
                &:first-child {
                    text-transform: uppercase;
                }
            }
        }
        .footer__paysistems {
            display: flex;
            gap: 16px;
        }
        .footer__copyright {
            @include font(14, 400);
            color: $bg-dark;
        }
        @media (max-width: $breakpoint-lg) {
            padding: 40px 16px;
            .footer__logo {
                img {
                    max-width: 195px;
                }
            }
            .footer__menu {
                display: flex;
                flex-direction: column;
                gap: 20px;
                margin-bottom: 40px;
                li {
                    a {
                        color: $main-light;
                        @include font(16, 400);
                        padding: 0;
                        transition: $transition;
                        &:hover {
                            background-color: $main-dark;
                            color: $main-light;
                        }
                    }
                }
            }
            .footer__contacts {
                height: calc(100% - 40px);
                margin-bottom: 40px;
                &-item {
                    @include font(12, 400);
                }
            }
            .footer__paysistems {
                margin-bottom: 20px;
                li {
                    width: auto !important;
                    height: 14px !important;
                }
            }
            .footer__copyright {
                @include font(12, 400);
            }
        }
    }
}
</style>